<template>
    <div class="home">
        <ProgramGroupRow
            v-if="heroRowGroup"
            :group-id="heroRowGroup.id"
            :has-user-suggestions="heroRowGroup.hasUserSuggestions"
            :title="heroRowGroup.title"
            item-style="hero"
        />
        <div class="row-container">
            <template v-for="(group, i) in nonEmptyGroups">
                <ProgramGroupRow
                    v-if="i >= detailRowIndex"
                    :key="i"
                    :group-id="group.id"
                    :title="group.title"
                    :has-user-suggestions="group.hasUserSuggestions"
                    :item-style="getStyle(i, group)"
                />
            </template>
        </div>
    </div>
</template>
<script>
// @ is an alias to /src
import ProgramGroupRow from '@/components/ProgramGroupRow.vue';

export default {
    name: 'HomeView',
    components: {
        ProgramGroupRow,
    },
    data: () => ({
        programGroups: [],
    }),
    computed: {
        heroRowGroup: function () {
            if (
                (this.programGroups[0]?.childCount > 0 ||
                    this.programGroups[0]?.hasUserSuggestions) &&
                (this.programGroups[0]?.rowStyle === 'default' ||
                    this.programGroups[0]?.rowStyle === 'hero')
            ) {
                return this.programGroups[0];
            }
            return undefined;
        },
        detailRowIndex: function () {
            if (this.heroRowGroup) {
                return 1;
            } else {
                return 0;
            }
        },
        nonEmptyGroups: function () {
            return this.programGroups.filter(
                (group) => group.childCount > 0 || group.hasUserSuggestions,
            );
        },
    },
    created() {
        this.loadGroups();
        this.$gideo.bus.$on('logged-out', this.loadGroups);
    },
    destroyed() {
        this.$gideo.bus.$off('logged-out', this.loadGroups);
    },
    methods: {
        getStyle(index, row) {
            if (index === this.detailRowIndex && row.rowStyle === 'default') {
                return 'highlight';
            }

            return row.rowStyle === 'default' ? 'poster' : row.rowStyle;
        },
        async loadGroups() {
            this.programGroups = [];
            const groups = await this.$gideo.getProgramGroups();
            this.programGroups = groups.data;
        },
    },
};
</script>

<style scoped lang="scss">
.home {
    overflow: hidden;
}
</style>
